var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger-container",on:{"click":_vm.toggleClick}},[_c('i',{staticClass:"hamburger",class:_vm.isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'})])
}
var staticRenderFns = []

export { render, staticRenderFns }